import { React, useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Drawer,
  List,
  ListItem,
} from "@mui/material";
import { Menu as MenuIcon, Close } from "@mui/icons-material";
import logo from "../../images/mujaahid-logo-white.png";
import "./header.css";
// import { makeStyles } from "@mui/styles"
import { Link } from "react-router-dom";

// const useStyle = makeStyles(() => ({
//     logo: {
//         fontFamily: "Work Sans, sans-serif",
//         fontWeight: 600,
//         color: "#FFFEFE",
//         textAlign: "left",
//     }
// }))

const Header = () => {
  const pages = [
    {
      label: "Home",
      href: "/",
      key: 1,
    },
    {
      label: "Gallery",
      href: "/gallery",
      key: 2,
    },
    {
      label: "About",
      href: "/about",
      key: 3,
    },
    {
      label: "Contact",
      href: "/contact",
      key: 4,
    },
  ];

  const [state, setState] = useState({
    mobileView: false,
  });
  const [drawer, setDrawer] = useState(false);
  const { mobileView } = state;

  // const { logo } = useStyle();

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth > 900
        ? setState((prevState) => ({ ...prevState, mobileView: false }))
        : setState((prevState) => ({ ...prevState, mobileView: true }));
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return window.removeEventListener("resize", () => setResponsiveness());
  }, []);

  const toggleDrawer = (val) => {
    setDrawer(val);
  };

  const displayMobile = () => {
    return (
      <Toolbar
        sx={{
          display: "flex",
          flexFlow: "row no-wrap",
          justifyContent: "space-between",
          padding: "0 1rem",
        }}
      >
        <Link to="/" style={{ textDecoration: "none" }}>
          <img src={logo} height="64rem" width="64rem" alt="Mujaahid Studio" />

          {/* <Typography variant="h4" component="h1" color="secondary">
            Mujaheed
          </Typography> */}
        </Link>

        <IconButton
          aria-label="menu"
          color="secondary"
          size="large"
          onClick={() => {
            toggleDrawer(true);
          }}
        >
          <MenuIcon fontSize="inherit" />
        </IconButton>
        <Drawer
          open={drawer}
          onClose={() => {
            toggleDrawer(false);
          }}
          className="draw"
        >
          <List>
            <ListItem sx={{ justifyContent: "center" }} fontSize="inherit">
              <Close
                onClick={() => {
                  toggleDrawer(false);
                }}
              />
            </ListItem>
            {pages.map(({ label, href, key }) => {
              return (
                <ListItem sx={{ justifyContent: "center" }} key={key}>
                  <Link
                    to={href}
                    style={{ textDecoration: "none" }}
                    onClick={() => {
                      toggleDrawer(false);
                    }}
                  >
                    <Typography variant="h5" color="primary">
                      {label}
                    </Typography>
                  </Link>
                </ListItem>
              );
            })}
          </List>
        </Drawer>
      </Toolbar>
    );
  };
  const displayDesktop = () => {
    return (
      <Toolbar
        sx={{
          display: "flex",
          flexFlow: "row no-wrap",
          justifyContent: "space-between",
          padding: "0 1rem",
        }}
      >
        <Link to="/" style={{ textDecoration: "none" }}>
          {/* <Typography variant="h4" component="h1" color="secondary">
            Mujaheed Studio
          </Typography> */}
          <img src={logo} height="64rem" width="64rem" alt="logo" />
        </Link>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
            width: "40%",
          }}
        >
          {pages.map(({ label, href, key }) => {
            return (
              <Link to={href} style={{ textDecoration: "none" }} key={key}>
                <Typography variant="h6" color="secondary">
                  {label}
                </Typography>
              </Link>
            );
          })}
        </Box>
      </Toolbar>
    );
  };

  return (
    <AppBar position="sticky">
      {mobileView ? displayMobile() : displayDesktop()}
    </AppBar>
  );
};

export default Header;
